import {
  ENTER_OTP_VALUE,
  OTP_SENT,
  get_request_config
} from '@/utils/system_constants/constant.js';
import axios from 'axios';
import OnboardingIndex from '../OnboardingIndex.vue';
import alert_mixin from '@/utils/mixins/alert_mixin';

const REQUESTOR_ROLE_MATCHERS = ['entity', 'requestor', 'requester'];
const OWNER_ROLE_MATCHERS = ['case owner', 'case_owner'];
const COMPLYON_HOME_ROUTE = 'CommandCentre';

const normalize_role = (role) => String(role || '').trim().toLowerCase();

const is_requestor_role = (normalized_role) =>
  REQUESTOR_ROLE_MATCHERS.some((role_matcher) => normalized_role.includes(role_matcher));

const is_owner_role = (normalized_role) =>
  OWNER_ROLE_MATCHERS.some((role_matcher) => normalized_role.includes(role_matcher))
  || normalized_role === 'owner'
  || normalized_role.endsWith(' owner');

export default {
  name: 'OneTimePin',
  mixins: [alert_mixin],
  components: {
    OnboardingIndex
  },
  data() {
    return {
      title: "Verify Your Account",
      submit_button_text: "Login",
      verification_running: false,
      otp_number: '',
      otp_sending: false
    };
  },

  computed: {
    post_otp_route_name() {
      const normalized_role = normalize_role(this.$store.getters.currentRole);

      if (is_requestor_role(normalized_role)) {
        return this.$router.hasRoute('RequestorDashboard')
          ? 'RequestorDashboard'
          : COMPLYON_HOME_ROUTE;
      }

      if (is_owner_role(normalized_role)) {
        return this.$router.hasRoute('OwnerDashboard')
          ? 'RequestorDashboard'
          : COMPLYON_HOME_ROUTE;
      }

      return this.$router.hasRoute('CompanyPortfolio')
        ? 'CompanyPortfolio'
        : COMPLYON_HOME_ROUTE;
    }
  },

  methods: {

    async handle_enter_otp() {
      const otp_number = String(this.otp_number || '').trim();

      if (!otp_number) {
        this.show_error('Please enter the OTP sent to your device.');
        return;
      }

      this.verification_running = true;

      const data = {
        one_time_password: otp_number,
        user_id: this.$store.getters.currentUserId
      };

      try {
        const response = await axios.post(
          ENTER_OTP_VALUE,
          data,
          get_request_config()
        );

        const response_data =
          typeof response.data === 'string' ? JSON.parse(response.data) : response.data;

        if (response_data.status === 'success') {
          sessionStorage.setItem('otp_verified', 'true');
          this.show_success('OTP verified successfully');
          await this.$router.replace({ name: this.post_otp_route_name });
        } else {
          this.show_error(response_data.message || 'Invalid OTP. Please try again.');
        }
      } catch (error) {
        this.show_error(
          error?.response?.data?.message || 'Please enter a valid OTP.'
        );
      } finally {
        this.verification_running = false;
      }
    },

    async resend_otp() {
      if (this.otp_sending) return;

      this.otp_sending = true;
      const user_id = this.$store.getters.currentUserId;

      try {
        const response = await axios.post(
          OTP_SENT,
          { user_id },
          get_request_config()
        );

        const response_data =
          typeof response.data === 'string' ? JSON.parse(response.data) : response.data;

        if (response_data.status === 'success') {
          this.show_success('OTP has been resent successfully.');

          if (response_data.user_id) {
            this.$store.dispatch('setCurrentUserId', response_data.user_id);
          }
        } else {
          this.show_error(response_data.message || 'Could not send OTP.');
        }
      } catch (error) {
        this.show_error(
          error?.response?.data?.message || 'Could not send OTP to user.'
        );
      } finally {
        this.otp_sending = false;
      }
    }
  }
};
